import { Component } from "@angular/core";
import { FileSystemAccessService } from "../../../_services/file-system-access.service";
import { TranslateService } from "@ngx-translate/core";
import { NetworkStatusService } from "../../../_services/network-status.service";
import { CommonSnackBarService } from "../../../_services/common-snack-bar.service";
import { LoginUserService } from "../../../_services/http-api/login-user.service";

@Component({
  selector: "app-desktop-menu",
  templateUrl: "./desktop-menu.component.html",
  styleUrl: "./desktop-menu.component.scss",
  standalone: false
})
export class DesktopMenuComponent {
  constructor(
    private fileSystemAccessService: FileSystemAccessService,
    private translate: TranslateService,
    private networkStatusService: NetworkStatusService,
    private snackbarService: CommonSnackBarService,
    private loginUserService: LoginUserService
  ) {}

  isGuestUser(): boolean {
    return this.loginUserService.isGuestRole();
  }

  goToBrianApp() {
    this.fileSystemAccessService.executeReturnAppBatFile().subscribe((fileExists) => {
      if (!fileExists) {
        this.snackbarService.open(this.translate.instant("desktopMenu.fileNotFound"));
      }
    });
  }

  isBrianMode(): boolean {
    return this.networkStatusService.isBrianMode;
  }
}
